import React from "react";
import Header from "../../Components/Header/Header";
import YourDecks from "../../Components/YourDecks/YourDeck";

const YourDeckPage = () => {
  return (
    <div>
      <Header />
      <YourDecks />
    </div>
  );
};

export default YourDeckPage;
